module.exports = __webpack_public_path__ + "static/media/support.62cec5c6.png";